module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp12_7016.60982567.png";